import React, { useState, useEffect } from "react";
import {
  Container,
  Nav,
  Navbar,
  Modal,
  Col,
  Row,
  Table,
  Offcanvas,
} from "react-bootstrap";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useLocation, Navigate } from "react-router-dom";
import API_DOMAIN from "../config/config";
import { MdOutlineClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import { ButtonBase } from "@mui/material";
import companyId from "../config/companyId";

const ProductHistory = [
  "S No",
  "Date",
  "Receipt No",
  "Name",
  "Total",
  "Status",
];

const calculateOutstanding = (party) => {
  if (!party || !party.transactions) return 0;
  let totalPurchases = 0;
  let totalPaidPurchases = 0;
  let totalPayouts = 0;
  party.transactions.forEach((t) => {
    if (t.type === "Purchase") {
      totalPurchases += parseFloat(t.amount) || 0;
      totalPaidPurchases += parseFloat(t.paid) || 0;
    } else if (t.type === "Payout") {
      totalPayouts += parseFloat(t.amount) || 0;
    }
  });
  const opening = parseFloat(party.opening_balance) || 0;
  return opening + totalPurchases - totalPaidPurchases - totalPayouts;
};

const PayOut = () => {
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const [show, setShow] = useState(false);
  const [tempSearchText, setTempSearchText] = useState("");
  const [crtPayOut, setCrtPayOut] = useState(null);
  const [formData, setFormData] = useState({
    party_id: "",
    voucher_date: new Date(),
    paid: "",
    payment_method_id: "",
    details: "",
  });
  const [outstanding, setOutstanding] = useState(0);
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [filterData, setFilterData] = useState({
    search_text: "",
    party_id: "",
    from_date: null,
    to_date: null,
  });
  const [loading, setLoading] = useState(false);
  const [purchasepartyData, setPurchasepartyData] = useState([]);
  console.log("purchasepartyData", purchasepartyData);
  const [crtPaymentMethod, setCrtPaymentMethod] = useState([]);
  const [userData, setUserData] = useState([]);
  const [filterKey, setFilterKey] = useState(Date.now());
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  const handleClose = () => {
    setShow(false);
    setCrtPayOut(null);
    setFormData({
      party_id: "",
      voucher_date: new Date(),
      paid: "",
      payment_method_id: "",
      details: "",
    });
    setOutstanding(0);
  };

  const handleShow = () => {
    setCrtPayOut(null);
    setFormData({
      party_id: "",
      voucher_date: new Date(),
      paid: "",
      payment_method_id: "",
      details: "",
    });
    setOutstanding(0);
    setShow(true);
  };

  const handleEditClick = (rowdata) => {
    const isValidDate = moment(
      rowdata.voucher_date,
      ["YYYY-MM-DD", "DD-MM-YYYY"],
      true
    ).isValid();
    const parsedDate = isValidDate
      ? moment(
        rowdata.voucher_date,
        ["YYYY-MM-DD", "DD-MM-YYYY"],
        true
      ).toDate()
      : new Date();

    setCrtPayOut({
      ...rowdata,
      voucher_date: parsedDate,
    });

    setShow(true);
  };

  const handleChanges = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtPayOut !== null) {
      setCrtPayOut({
        ...crtPayOut,
        [fieldName]: value,
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };

  const setFormattedDate = (
    value,
    field,
    format = "YYYY-MM-DD",
    isFilter = false
  ) => {
    const formattedDate = value ? moment(value).format(format) : null;

    if (!formattedDate || !moment(formattedDate, format, true).isValid()) {
      return;
    }

    const newDateState = { [field]: formattedDate };

    if (isFilter) {
      setFilterData((prev) => ({ ...prev, ...newDateState }));
    } else if (crtPayOut !== null) {
      setCrtPayOut((prev) => ({ ...prev, ...newDateState }));
    } else {
      setFormData((prev) => ({ ...prev, ...newDateState }));
    }
  };

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: null,
      to_date: null,
    });
    setTempSearchText("");
    setFilterKey(Date.now());
  };

  const fetchAllPayoutData = async () => {
    setLoading(true);
    try {
      const payoutPayload = {
        search_text: filterData.search_text || "",
        party_id: filterData.party_id || "",
        from_date: filterData.from_date || "",
        to_date: filterData.to_date || "",
        company_id: companyId,
      };

      const [partyRes, paymentRes, payoutRes] = await Promise.all([
        fetch(`${API_DOMAIN}/purchase_party.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", company_id: companyId }),
        }),
        fetch(`${API_DOMAIN}/paymentmethod.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
        fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payoutPayload),
        }),
      ]);

      // 1. Parse all responses safely
      const partyJson = await partyRes.json().catch(() => ({ status: 400 }));
      const paymentJson = await paymentRes.json().catch(() => ({ status: 400 }));
      const payoutJson = await payoutRes.json().catch(() => ({ status: 400 }));

      // 2. Set states (for dropdowns & future use)
      if (partyJson.status === 200) {
        setPurchasepartyData(partyJson.data || []);
      } else {
        setPurchasepartyData([]);
      }

      if (paymentJson.status === 200) {
        setCrtPaymentMethod(paymentJson.data || []);
      } else {
        setCrtPaymentMethod([]);
      }

      // 3. If payouts failed → early exit
      if (payoutJson.status !== 200) {
        toast.error(payoutJson.msg || "Failed to fetch payout data");
        setUserData([]);
        return;
      }

      // 4. Use the freshly fetched partyJson.data for mapping (this is the fix!)
      const partyList = partyJson.status === 200 ? partyJson.data : [];

      const enrichedData = (payoutJson.data || []).map((item) => {
        const party = partyList.find((p) => p.party_id === item.party_id);
        return {
          ...item,
          party_name: party?.party_name || "Unknown Party",
          voucher_date: item.voucher_date || "",
        };
      });

      setUserData(enrichedData);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error fetching data");
      setUserData([]);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    try {
      if (!companyId) {
        errorAlert("Company ID missing!");
        return;
      }

      if (
        !formData.party_id ||
        !formData.voucher_date ||
        !formData.paid ||
        !formData.payment_method_id
      ) {
        errorAlert("All fields are required!");
        return;
      }

      if (!moment(formData.voucher_date, "DD-MM-YYYY", true).isValid()) {
        errorAlert("Invalid voucher date format! Please use DD-MM-YYYY.");
        return;
      }

      const formattedData = {
        ...formData,
        voucher_date: moment(formData.voucher_date, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        ),
        company_id: companyId,
        details: formData.details,
      };
      setLoading(true);
      const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formattedData),
      });

      if (!response.ok) {
        const text = await response.text();
        toast.error(`Payout API error: ${response.status}`, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        toast.error("Invalid response format from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const responseText = await response.text();
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (err) {
        setLoading(false);
        toast.error("Invalid response from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      if (responseData.status === 200) {
        setFormData({
          party_id: "",
          voucher_date: "",
          paid: "",
          payment_method_id: "",
        });
        toast.success("PayOut Created successfully!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => {
          fetchAllPayoutData();
          handleClose();
        }, 2000);
      } else {
        errorAlert(responseData.msg || "Failed to create payout");
      }
    } catch (error) {
      toast.error("Error while submitting payout", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      if (!companyId) {
        errorAlert("Company ID missing!");
        return;
      }

      if (
        !crtPayOut.party_id ||
        !crtPayOut.voucher_date ||
        !crtPayOut.paid ||
        !crtPayOut.payment_method_id
      ) {
        errorAlert("All fields are required!");
        return;
      }

      if (!moment(crtPayOut.voucher_date, "DD-MM-YYYY", true).isValid()) {
        errorAlert("Invalid voucher date format! Please use DD-MM-YYYY.");
        return;
      }

      const formattedData = {
        payout_id: crtPayOut.payout_id,
        paid: crtPayOut.paid,
        voucher_date: moment(crtPayOut.voucher_date, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        ),
        party_id: crtPayOut.party_id,
        payment_method_id: crtPayOut.payment_method_id,
        company_id: companyId,
        details: crtPayOut.details,
      };

      const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formattedData),
      });

      if (!response.ok) {
        const text = await response.text();
        toast.error(`Payout API error: ${response.status}`, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const contentType = response.headers.get("Content-Type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        toast.error("Invalid response format from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      const responseText = await response.text();
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (err) {
        toast.error("Invalid response from payout API", {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      if (responseData.status === 200) {
        successAlert(responseData.msg || "Payout updated successfully");
        setTimeout(() => {
          handleClose();
          fetchAllPayoutData();
        }, 2000);
      } else {
        errorAlert(responseData.msg || "Failed to update payout");
      }
    } catch (error) {
      toast.error("Error while updating payout", {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  const filteredUserData = userData.filter((item) => {
    const voucherNo = item.voucher_no?.toString().toLowerCase() || "";
    const receiptNo = item.receipt_no?.toString().toLowerCase() || "";
    const partyName = item.party_name?.toLowerCase() || "";
    const searchText = filterData.search_text?.toString().toLowerCase() || "";

    const isSearchMatch =
      searchText === "" ||
      voucherNo.includes(searchText) ||
      receiptNo.includes(searchText) ||
      partyName.includes(searchText);

    const isPartyMatch =
      !filterData.party_id || item.party_id === filterData.party_id;

    const itemDate = moment(item.voucher_date, "YYYY-MM-DD", true);
    const fromDate = filterData.from_date
      ? moment(filterData.from_date, "YYYY-MM-DD", true)
      : null;
    const toDate = filterData.to_date
      ? moment(filterData.to_date, "YYYY-MM-DD", true)
      : null;

    const isDateMatch =
      ((!fromDate || !fromDate.isValid()) && (!toDate || !toDate.isValid())) ||
      (fromDate &&
        fromDate.isValid() &&
        toDate &&
        toDate.isValid() &&
        itemDate.isValid() &&
        itemDate.isBetween(fromDate, toDate, "day", "[]")) ||
      (fromDate &&
        fromDate.isValid() &&
        !toDate &&
        itemDate.isValid() &&
        itemDate.isSameOrAfter(fromDate, "day")) ||
      (!fromDate &&
        toDate &&
        toDate.isValid() &&
        itemDate.isValid() &&
        itemDate.isSameOrBefore(toDate, "day"));

    return (
      isSearchMatch &&
      isPartyMatch &&
      (itemDate.isValid() ? isDateMatch : false)
    );
  });

  useEffect(() => {
    fetchAllPayoutData();
  }, []);

  useEffect(() => {
    const currentPartyId = crtPayOut ? crtPayOut.party_id : formData.party_id;
    if (currentPartyId && purchasepartyData.length > 0) {
      const party = purchasepartyData.find(
        (p) => p.party_id === currentPartyId
      );
      if (party) {
        setOutstanding(calculateOutstanding(party));
      } else {
        setOutstanding(0);
      }
    } else {
      setOutstanding(0);
    }
  }, [formData.party_id, crtPayOut?.party_id, purchasepartyData]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilterData((prev) => ({
        ...prev,
        search_text: tempSearchText,
      }));
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [tempSearchText]);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading PayoutPage..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main p-3 my-2">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle="Pay Out" />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={showFilter} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Clear</>} onClick={clearFilter} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle="Purchase Bill" />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons onClick={closeFilter} lable={<MdOutlineClose />} />
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    labelname="Search Receipt"
                    placeholder="Search Receipt"
                    name="search_text"
                    value={tempSearchText}
                    onChange={(e) => setTempSearchText(e.target.value)}
                  />
                </div>
                <div className="py-3">
                  <DropDownUI
                    key={filterKey}
                    optionlist={purchasepartyData.map((user) => ({
                      value: user.party_id,
                      label: user.party_name,
                    }))}
                    placeholder="Select Party"
                    labelname="Select Party"
                    name="party_id"
                    value={filterData.party_id}
                    onChange={(updatedFormData) =>
                      setFilterData({
                        ...filterData,
                        party_id: updatedFormData.party_id,
                      })
                    }
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <Calender
                      key={filterKey}
                      calenderlabel="From Date"
                      selectedDate={
                        filterData.from_date &&
                          moment(
                            filterData.from_date,
                            "YYYY-MM-DD",
                            true
                          ).isValid()
                          ? moment(filterData.from_date, "YYYY-MM-DD").toDate()
                          : null
                      }
                      setLabel={(date) =>
                        setFormattedDate(date, "from_date", "YYYY-MM-DD", true)
                      }
                      disabled={false}
                    />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <Calender
                      key={filterKey}
                      calenderlabel="To Date"
                      selectedDate={
                        filterData.to_date &&
                          moment(filterData.to_date, "YYYY-MM-DD", true).isValid()
                          ? moment(filterData.to_date, "YYYY-MM-DD").toDate()
                          : null
                      }
                      setLabel={(date) =>
                        setFormattedDate(date, "to_date", "YYYY-MM-DD", true)
                      }
                      disabled={false}
                    />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons
                        lable="Apply"
                        onClick={() => {
                          closeFilter();
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable="Clear" onClick={clearFilter} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle="Transactions" />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Add New</>} onClick={handleShow} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll">
            <TableUI
              headers={ProductHistory}
              body={filteredUserData.map((item) => ({
                ...item,
                voucher_date: moment(
                  item.voucher_date,
                  "YYYY-MM-DD",
                  true
                ).isValid()
                  ? item.voucher_date
                  : "",
              }))}
              type="purchasepayout"
              pageview="yes"
              handleEditClick={handleEditClick}
              onDelete={fetchAllPayoutData}
            />
          </div>
        </div>
      </Container>
      <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
        <Modal.Header>
          <Modal.Title>
            <PageHead
              pagehead={`PayOut${crtPayOut !== null ? " Update" : " Creation"}`}
              onClick={handleClose}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Table>
              <>
                <div className="row">
                  <div className="col-12 col-md-4">
                    <Calender
                      calenderlabel="Date"
                      selectedDate={
                        (crtPayOut
                          ? crtPayOut.voucher_date
                          : formData.voucher_date) &&
                          moment(
                            crtPayOut
                              ? crtPayOut.voucher_date
                              : formData.voucher_date,
                            "DD-MM-YYYY",
                            true
                          ).isValid()
                          ? moment(
                            crtPayOut
                              ? crtPayOut.voucher_date
                              : formData.voucher_date,
                            "DD-MM-YYYY"
                          ).toDate()
                          : null
                      }
                      setLabel={(date) =>
                        setFormattedDate(
                          date,
                          "voucher_date",
                          "DD-MM-YYYY",
                          false
                        )
                      }
                      disabled={false}
                    />
                  </div>

                  {/* 2. Select Party */}
                  <div className="col-12 col-md-4">
                    <DropDownUI
                      optionlist={purchasepartyData.map((user) => ({
                        value: user.party_id,
                        label: user.party_name,
                      }))}
                      placeholder="Select Party"
                      labelname="Select Party"
                      name="party_id"
                      value={
                        crtPayOut !== null
                          ? crtPayOut.party_id
                          : formData.party_id
                      }
                      onChange={(updatedFormData) => {
                        if (crtPayOut !== null) {
                          setCrtPayOut({
                            ...crtPayOut,
                            party_id: updatedFormData.party_id,
                          });
                        } else {
                          setFormData({
                            ...formData,
                            party_id: updatedFormData.party_id,
                          });
                        }
                      }}
                    />
                  </div>

                  {/* 3. Select Payment */}
                  <div className="col-12 col-md-4">
                    <DropDownUI
                      optionlist={crtPaymentMethod.map((user) => ({
                        value: user.payment_method_id,
                        label: user.payment_method_name,
                      }))}
                      placeholder="Select Payment"
                      labelname="Select Payment"
                      name="payment_method_id"
                      value={
                        crtPayOut !== null
                          ? crtPayOut.payment_method_id
                          : formData.payment_method_id
                      }
                      onChange={(updatedFormData) => {
                        if (crtPayOut !== null) {
                          setCrtPayOut({
                            ...crtPayOut,
                            payment_method_id:
                              updatedFormData.payment_method_id,
                          });
                        } else {
                          setFormData({
                            ...formData,
                            payment_method_id:
                              updatedFormData.payment_method_id,
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                {/* --- Second Row: Details and Paid (3 Columns for alignment) --- */}
                <div className="row">
                  {/* 1. Details (Added based on your request) */}
                  <div className="col-12 col-md-4">
                    <div className="py-3">
                      <TextInputForm
                        labelname={"Details"}
                        placeholder={"Enter Details (Optional)"}
                        name="details"
                        value={
                          crtPayOut !== null
                            ? crtPayOut.details
                            : formData.details
                        }
                        // Assuming you have a handleChange function defined
                        onChange={(e) => handleChange(e, "details")}
                      />
                    </div>
                  </div>

                  {/* 2. Paid */}
                  <div className="col-12 col-md-4">
                    <div className="py-3">
                      <TextInputForm
                        labelname="Paid"
                        placeholder="Paid"
                        name="paid"
                        value={
                          crtPayOut !== null ? crtPayOut.paid : formData.paid
                        }
                        onChange={(e) => handleChange(e, "paid")}
                      />
                    </div>
                  </div>

                  {/* 3. Empty Column for Alignment */}
                  <div className="col-12 col-md-4">
                    {/* Spacer column to maintain alignment with the row above */}
                  </div>
                </div>

                {/* Outstanding Card */}
                {outstanding > 0 && (
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body text-center">
                          <h6 className="text-danger">
                            Outstanding Amount: ₹{outstanding.toFixed(2)}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            </Table>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Col lg="12" md="12" xs="12" className="py-5 align-self-center">
            <div className="text-center">
              {crtPayOut !== null ? (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <ClickButton
                      label={<>Update</>}
                      disabled={loading}
                      onClick={handleUpdateSubmit}
                    />
                  </span>
                  <span className="mx-2">
                    <ClickButton label={<>Cancel</>} onClick={handleClose} />
                  </span>
                </>
              ) : (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <ClickButton
                      label={<>Submit</>}
                      onClick={handleSubmit}
                      disabled={loading}
                    />
                  </span>
                  <span className="mx-2">
                    <ClickButton label={<>Cancel</>} onClick={handleClose} />
                  </span>
                </>
              )}
            </div>
          </Col>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PayOut;

